import { CheckOutlined, ClockCircleOutlined, CloseOutlined, InfoCircleOutlined, SwapOutlined, WarningOutlined } from "@ant-design/icons";

const DEMO = {
  //  link: 'javascript:;', // javascript:;
  home: '#/app/dashboard',
  home2: '/app/dashboard',
  productLink: 'https://themeforest.net/item/ant-design-reactjs-admin-with-bootstrap/22194157',
  user: 'Lisa',
  login: '#/user/login',
  signUp: '#/user/sign-up',
  forgotPassword: '#/user/forgot-password',
}

// header links
DEMO.headerLink = {
  profile: '#/app/page/about',
  about: '#/app/page/about',
  help: '#/app/page/contact',
  signOut: '#/user/login' // redirect login page
}

export default DEMO;

export const dias = [
  { name: 'lunes', label: 'Lunes', dia: 1 },
  { name: 'martes', label: 'Martes', dia: 2 },
  { name: 'miercoles', label: 'Miércoles', dia: 3 },
  { name: 'jueves', label: 'Jueves', dia: 4 },
  { name: 'viernes', label: 'Viernes', dia: 5 },
  { name: 'sabado', label: 'Sábado', dia: 6 },
  { name: 'domingo', label: 'Domingo', dia: 0 }
];

export const estados = [
  {
    id: 1,
    icon: <CheckOutlined />,
    state: 'AUTORIZADO',
    title: 'Autorizado',
    color: '#49aa19',
  }, {
    id: 2,
    icon: <InfoCircleOutlined />,
    state: 'INCOMPLETO',
    title: 'Incompleto',
    color: '#E3651D',
  }, {
    id: 3,
    icon: <ClockCircleOutlined />,
    state: 'PENDIENTE',
    title: 'Pendiente',
    color: '#1668dc',
  }, {
    id: 4,
    icon: <SwapOutlined />,
    state: 'EN_TRAMITE',
    title: 'En trámite',
    color: 'gray',
  }, {
    id: 5,
    icon: <CloseOutlined />,
    state: 'RECHAZADO',
    title: 'Rechazado',
    color: '#dc4446',
  }, {
    id: 6,
    icon: <WarningOutlined />,
    state: 'VENCIDO',
    title: 'Vencido',
    color: '#dc4446',
  }, {
    id: 7,
    icon: <CheckOutlined />,
    state: 'COMPLETADO',
    title: 'Completado',
    color: '#49aa19',
  },
];

export const documentos = {
  CONTRATO_AGENCIA: 1,
  DDJJ_SECRETO_POSTAL_PERSONAL: 2,
  DDJJ_SECRETO_INEXISTENCIA_PERSONAL: 4,
  DDJJ_SECRETO_INEXISTENCIA_CONTRATISTA: 5,
  DDJJ_SECRETO_POSTAL_TITULAR: 6,
};

export const TIPOS_DOMICILIOS = {
  CLIENTE: 1,
  DOMICILIO: 2,
  PUNTOS_ENTREGA: 3,
  ENTREGA_RETIRO: 4,
};

export const TIPOS_DOMICILIOS_TITULOS = {
  1: 'cliente',
  2: 'domicilio',
  3: 'puntos de entrega',
  4: 'entrega/retiro',
};

export const ARTICULOS = {
  FLETE_DISTANCIA_PESO: 119,
  FLETE_DISTANCIA_VOLUMEN: 126,
};

export const ACUERDOS_TIPOS = {
  FLETE_DISTANCIA_PESO: 1,
  FLETE_DISTANCIA_VOLUMEN: 2,
  ESPECIFICO: 3,
  VALOR_DECLARADO: 4,
  PERSONALIZADO: 5,
};

export const ACUERDOS_TITLE = {
  plural: 'Acuerdos',
  singular: 'Acuerdo',
};

export const UNIDADES_MEDIDAS = {
  BULTOS: 3,
  VOLUMEN: 4,
  PESO: 5,
  PESO_VOLUMETRICO: 8,
};

export const UNIDADES_MEDIDAS_OBJ = {
  BULTOS: { id: UNIDADES_MEDIDAS.BULTOS, nombre: 'Bulto', suffix: 'u', abreviatura: '@ u' },
  VOLUMEN: { id: UNIDADES_MEDIDAS.VOLUMEN, nombre: 'Volumen', suffix: 'm³', abreviatura: '@ m³' },
  PESO: { id: UNIDADES_MEDIDAS.PESO, nombre: 'Peso', suffix: 'kg', abreviatura: '@ kg' },
  PESO_VOLUMETRICO: { id: UNIDADES_MEDIDAS.PESO_VOLUMETRICO, nombre: 'Peso Volumetrico', suffix: 'kg', abreviatura: '@ kg' },
}

export const AUTORIZACIONES_TIPOS = {
  ACUERDOS: 1,
  NOTAS_CREDITO: 2,
  CAMBIO_FILIAL_COB: 3,
  AUTOGESTION: 4,
  ENVIOS: 5,
  RECIBOS_AUTOMATICOS: 6,
  CONCILIACIONES: 7,
};

export const AUTORIZACIONES_ESTADOS = {
  PENDIENTE: 1,
  AUTORIZADO: 2,
  RECHAZADO: 3,
  GENERADO: 4,
};

export const TABS_PRECIOS = {
  DISTANCIAS: '1',
  ADICIONALES: '2',
  SEGUROS: '3',
}

export const SUBRUBROS = {
  FLETE_DISTANCIA: 15,
};

export const ERRORES_PERMITIDOS_AFIP = [
  "No responde al requerimiento",
  "La CUIT registra pendiente la declaracion de los datos de contacto (mail y teléfono) y/o su asociacion al Domicilio Fiscal Electronico.",
  "La CUIT registra pendiente la constitución del domicilio fiscal electrónico de acuerdo a lo normado en la RG 4280/18 AFIP.",
  "La CUIT registra requerimientos pendientes de verificaciones."
];

export const VEHICULOS_SALIDAS_ESTADOS = {
  PENDIENTE: "Pendiente de Salida",
  EN_CAMINO: "En camino",
  COMPLETADO: "Recorrido terminado",
};

export const dayColors = {
  "Lunes": "#FDF669", // Amarillo
  "Martes": "#FF9900", // Naranja
  "Miércoles": "#FD7567", // Rojo
  "Jueves": "#00E74C",  // Verde
  "Viernes": "#6A94FA", // Azul
  "Sábado": "#9067FD",  // Púrpura
  "Domingo": "#67DFDF", // Azul claro
};

export const clientColors = {
  "yellow": "#FDF669",
  "orange": "#FF9900",
  "red": "#FD7567",
  "green": "#00E74C",
  "blue": "#6A94FA",
};

export const RUTAS_TIPOS = {
  PRONTA_ENTREGA: 1,
  PREVENTA: 2,
  ENTREGA: 3,
};

export const DISTRIBUCIONES_EVENTOS_TIPOS = {
  DESCARGA_PICKUP: 'DESCARGA PICKUP',
  CARGA_PICKUP: 'CARGA PICKUP',
  ENTREGA: 'Entrega',
  RETIRO: 'RETIRO',
  AVISO_VISITA: 'AVISO DE VISITA',
};

export const DISTRIBUCIONES_TIPOS = [
  { id: 1, tipo: "Troncal", url: "/troncal" },
  { id: 2, tipo: "Lateral", url: "/lateral" },
  { id: 3, tipo: "Última Milla", url: "/ultimamilla" },
  { id: 4, tipo: "Despacho", url: "/despacho" },
  { id: 5, tipo: "Entrega", url: "/entrega" },
];

export const ESTADOS_PEDIDO_RETIRO = {
  1: { label: "Pendiente", color: "orange" },
  2: { label: "Ruteado", color: "green" },
  3: { label: "Rechazado", color: "red" },
  4: { label: "Cancelado", color: "red" },
  5: { label: "Retirado", color: "blue" },
  6: { label: "Visitado sin realizar", color: "yellow" },
  7: { label: "Facturado", color: "cyan" },
};

export const TIPOS_ESTADOS_PEDIDO_RETIRO = {
  PENDIENTE: 1,
  ACEPTADO: 2,
  RECHAZADO: 3,
  CANCELADO: 4,
  COMPLETADO: 5,
};

export const TIPOS_SOLICITUDES = {
  SOPORTE: 1,
  PEDIDO: 2,
  PROPIEDADES: 3,
  VALIDACION: 4,
  INCIDENTES: 5,
  SINIESTROS: {
    ROTURAS: 6,
    FALTANTES: 7,
    ROBO: 8,
    EXTRAVIO: 9,
    INCENDIO: 10,
    VUELCO: 11,
  }
};

export const TIPOS_ESTADOS_SOLICITUDES = {
  PAGO_PENDIENTE: 2,
  INICIADO: 11,
  RECHAZADO: 9,
  EN_PREPARACION: 15,
}

export const TIPOS_NOTIFICACIONES = {
  AUTORIZACION: 1,
  SOLICITUD: 2,
}

export const TIPOS_PARADAS = {
  CLIENTE: 1,
  FILIAL: 2,
  RETIRO: 3,
  COBRANZA: 4,
}

export const PERIODOS = [
  {
    id: 1,
    dias: 30,
    descripcion: 'Mensual',
    vencimiento: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  },
  {
    id: 2,
    dias: 60,
    descripcion: 'Bimestral',
    vencimiento: [2, 4, 6, 8, 10, 12],
  },
  {
    id: 3,
    dias: 90,
    descripcion: 'Trimestral',
    vencimiento: [3, 6, 9, 12],
  },
  {
    id: 5,
    dias: 1,
    descripcion: 'No aumenta',
    vencimiento: [3]
  },
];

export const opcionTodas = { value: null, label: 'TODAS', disabled: true };

export const CONDICIONES_COBRO = [
  {
    id: 1,
    descripcion: 'CONTADO',
  },
  {
    id: 2,
    descripcion: 'PAGO DESTINO',
  },
   {
    id: 3,
    descripcion: 'CUENTA CORRIENTE',
  },
];

export const CONDICION_COBRO = {
  CONTADO: 1,
  PAGO_DESTINO: 2,
  CUENTA_CORRIENTE: 3,
}